/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AdminSlideFlag } from './AdminSlideFlag';
import type { LabOrderPatient } from './LabOrderPatient';
import type { UserName } from './UserName';

export type AdminLabOrderList = {
    readonly id?: number;
    readonly case_id?: number;
    readonly slide_id?: number;
    readonly lab_panel_id?: number;
    type: AdminLabOrderList.type;
    /**
     * number representing the sequential order in which the slide's specimen was cut for this Order
     */
    sequence: number;
    /**
     * special instructions for the lab via the pathologist
     */
    note?: string | null;
    readonly created_at?: string;
    readonly updated_at?: string;
    cancelled_at?: string | null;
    completed_at?: string | null;
    readonly transmitting_at?: string;
    readonly user?: UserName;
    readonly block_id?: number;
    readonly lab_stain_id?: number;
    inadequate?: boolean;
    no_charge_reason?: AdminLabOrderList.no_charge_reason | null;
    readonly case_accession?: string;
    readonly flag?: AdminSlideFlag;
    readonly slide_name?: string;
    readonly block_name?: string;
    readonly printed_at?: string;
    readonly printed_by?: string;
    readonly patient?: LabOrderPatient;
    readonly clinic_tat?: boolean;
    readonly case_priority?: string;
}

export namespace AdminLabOrderList {

    export enum type {
        STAIN = 'stain',
        RECUT = 'recut',
        RESCAN = 'rescan',
        LEVEL = 'level',
        OTHER = 'other',
        CONTROL = 'control',
    }

    export enum no_charge_reason {
        STAIN_NOT_OPTIMAL = 'stain-not-optimal',
        ACADEMIC = 'academic',
        NONCONTRIBUTORY = 'noncontributory',
        ORDERED_ERROR = 'ordered-error',
        INCORRECT_STAIN = 'incorrect-stain',
        PROCESSING_NOT_OPTIMAL = 'processing-not-optimal',
    }


}
